// extracted by mini-css-extract-plugin
export var cell = "_67-4";
export var headerCell = "_67-2";
export var rowHeader = "_67-3";
export var table = "_67-1";
export var tableContainer = "_67-0";